var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayersOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layers-solid",
    transform: "translate(-1.995 -4.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43915",
    "data-name": "Path 43915",
    d: "M10.993,13.649a.539.539,0,0,1-.242-.059l-8.433-4.2a.606.606,0,0,1,0-1.072l8.433-4.2a.536.536,0,0,1,.478,0l8.433,4.2a.606.606,0,0,1,0,1.072l-8.433,4.2a.539.539,0,0,1-.236.059Z",
    transform: "translate(0)",
    fill: "#505f7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43916",
    "data-name": "Path 43916",
    d: "M10.993,22.454a.539.539,0,0,1-.242-.059L2.318,18.214a.606.606,0,0,1-.27-.788.55.55,0,0,1,.748-.284l8.2,4.068,8.191-4.08a.556.556,0,0,1,.756.287.613.613,0,0,1-.273.8l-8.433,4.2A.537.537,0,0,1,10.993,22.454Z",
    transform: "translate(0 -5.02)",
    fill: "#505f7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43917",
    "data-name": "Path 43917",
    d: "M10.993,28.361a.539.539,0,0,1-.242-.059L2.318,24.1a.606.606,0,0,1-.27-.788.55.55,0,0,1,.748-.284l8.2,4.1,8.191-4.08a.55.55,0,0,1,.748.284.606.606,0,0,1-.27.788l-8.427,4.193A.537.537,0,0,1,10.993,28.361Z",
    transform: "translate(0 -7.297)",
    fill: "#505f7b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayersOutline);
export default __webpack_public_path__ + "static/media/layersOutline.531f833f.svg";
export { ForwardRef as ReactComponent };